var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import CorePanel from "@/prefabs/core/Panel";
import config from "@/config";
var createSwitchButton = function (scene, x, y, callback, isActiveParam) {
    var isActive = isActiveParam;
    var activeString = isActive ? "active" : "passive";
    var switchBackground = new Phaser.GameObjects.Image(scene, 0, 0, "switch.background." + activeString);
    var activeOffsetX = switchBackground.width / 2 - 30;
    var passiveOffsetX = 30 - switchBackground.width / 2;
    var switchButton = new Phaser.GameObjects.Image(scene, isActive ? activeOffsetX : passiveOffsetX, 5, "switch.button." + activeString);
    var panelInfoText = new Phaser.GameObjects.Text(scene, -120, -50, "SETTINGS", {
        fontFamily: config.graphics.fontFamily,
        color: "#571ccb",
        align: "center",
    }).setFontSize(18);
    panelInfoText.lineSpacing = -40;
    switchBackground
        .setInteractive({
        useHandCursor: true,
    })
        .on("pointerdown", function () {
        var newOffsetX = isActive ? passiveOffsetX : activeOffsetX;
        var newBackgroundTextureName = "switch.background.".concat(isActive ? "passive" : "active");
        var newButtonTextureName = "switch.button.".concat(isActive ? "passive" : "active");
        isActive = !isActive;
        switchButton.setPosition(newOffsetX, 5);
        switchBackground.setTexture(newBackgroundTextureName);
        switchButton.setTexture(newButtonTextureName);
        callback && callback(isActive);
    });
    return new Phaser.GameObjects.Container(scene, x, y, [
        switchBackground,
        switchButton,
    ]);
};
var PanelSettings = /** @class */ (function (_super) {
    __extends(PanelSettings, _super);
    function PanelSettings(scene, x, y, widthParam, heightParam, callbackExit, callbackMusic, callbackSound, settingsData) {
        var _this = _super.call(this, scene, x, y) || this;
        return _this;
        var width = widthParam;
        var height = heightParam;
        var rectangle = new Phaser.GameObjects.Rectangle(scene, 0, 0, width, height, 0x17171d, 0.7);
        var popup = new Phaser.GameObjects.Image(scene, 0, 0, "background.popup");
        var exitButton = new Phaser.GameObjects.Image(scene, 225, -125, "button.exit.red")
            .setInteractive({
            useHandCursor: true,
        })
            .on("pointerdown", callbackExit);
        var panelInfoText = new Phaser.GameObjects.Text(scene, 0, -popup.width / 2.7, "SETTINGS", {
            fontFamily: config.graphics.fontFamily,
            color: "#FFFFFF",
            align: "center",
        })
            .setFontSize(18)
            .setOrigin(0.5, 0);
        panelInfoText.lineSpacing = -40;
        var containerMusic = new Phaser.GameObjects.Container(scene, 0, -25, [
            new Phaser.GameObjects.Image(scene, -175, 0, "icon.music"),
            new Phaser.GameObjects.Text(scene, -90, 0, "Music", {
                align: "left",
                fontSize: "42px",
                fontFamily: config.graphics.fontFamily,
                color: "#5F1FE0",
            }).setOrigin(0.5),
            createSwitchButton(scene, 125, 0, callbackMusic, settingsData.audio),
        ]);
        var containerSound = new Phaser.GameObjects.Container(scene, 0, 100, [
            new Phaser.GameObjects.Image(scene, -175, 0, "icon.sound"),
            new Phaser.GameObjects.Text(scene, -90, 0, "Sound", {
                align: "left",
                fontSize: "42px",
                fontFamily: config.graphics.fontFamily,
                color: "#5F1FE0",
            }).setOrigin(0.5),
            createSwitchButton(scene, 125, 0, callbackSound, settingsData.sfx),
        ]);
        _this.add(rectangle);
        _this.add(popup);
        _this.add(exitButton);
        _this.add(containerMusic);
        _this.add(containerSound);
        _this.add(panelInfoText);
        _this.setDepth(99997);
        return _this;
    }
    return PanelSettings;
}(CorePanel));
export default PanelSettings;
